import { render, staticRenderFns } from "./peoplePosition.vue?vue&type=template&id=acb4ef48&scoped=true"
import script from "./peoplePosition.vue?vue&type=script&lang=js"
export * from "./peoplePosition.vue?vue&type=script&lang=js"
import style0 from "./peoplePosition.vue?vue&type=style&index=0&id=acb4ef48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb4ef48",
  null
  
)

export default component.exports